import React, { useEffect, useState } from 'react'
import CustomArticleTable from '../features/articles/components/CustomeArticleTable'
import useArticle from '../hooks/useArticles';
import { Button } from 'rsuite';
import { Article } from '../common.interface';
import CustomArticleModal from '../features/articles/components/customArticleModal';

function ArticlePage() {

 const {loading,articlesData} = useArticle();
 useEffect(()=>{
  console.log("======Articles data changed======")
 },[articlesData])

  
  const [modalData,setModalData] = useState<Article>({
    'imageUrl':'',
    'title':'',
    'content':'',
    'author':'',});

  const [showModal,setShowModal] = useState<boolean>(false);

  const displayModal = (id?:string) => {
    if(id){
      const newData = articlesData.filter((article)=>article._id===id)[0];
      setModalData(newData);
      setShowModal((prev)=>!prev);
  }
    else{
      setShowModal((prev)=>!prev);
    }
    
  }

  const handleOpen = () => {
    setShowModal((prev)=>!prev);
    setModalData(
      {
        '_id':'',
        'imageUrl':'',
        'title':'',
        'content':'',
        'author':'',
      }
    )
  }

  return (
    <div className='pt-2 pr-2 flex flex-col w-full'>
      <p className='mb-2 font-semibold' > ARTICLES MANAGEMENT</p>
      <div className='flex w-full flex-row'>
          <Button onClick={()=>displayModal()} appearance='primary' color='orange' >Create Article</Button>
      </div>

      <CustomArticleTable data={articlesData} myFunction={displayModal} loading={loading} actionText={'Update'}/>
      <CustomArticleModal open={showModal} handleOpen={handleOpen} data={modalData} setData={setModalData}/>
    </div>
  )
}

export default ArticlePage